import { createFileRoute } from "@tanstack/react-router"

import { organizationSettingsEmailDomainsViewStaticData } from "../../../../../../../views/OrganizationSettingsEmailDomainsView/constants"
import { OrganizationSettingsEmailDomainsView } from "../../../../../../../views/OrganizationSettingsEmailDomainsView/OrganizationSettingsEmailDomainsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/organization/email-domains")({
	component: OrganizationSettingsEmailDomainsView,
	staticData: organizationSettingsEmailDomainsViewStaticData,
})
